import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-5" }, "Dashboard", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_5 = { class: "card p-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Register new plan")
const _hoisted_7 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_8 = { class: "card p-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Review sales report")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-12 mb-3 mx-auto" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card p-4" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "btn btn-primary",
        href: "mailto:support@avteka.com"
      }, "Help")
    ])
  ])
], -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-5 col-md-12 mb-4" }
const _hoisted_14 = {
  key: 0,
  class: "col-lg-7 col-md-12 mb-4"
}
const _hoisted_15 = {
  key: 1,
  class: "col-lg-5 col-md-12 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_QuickActions = _resolveComponent("QuickActions")!
  const _component_SalesOverview = _resolveComponent("SalesOverview")!
  const _component_PayoutCompensationBody = _resolveComponent("PayoutCompensationBody")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.isHomePage && _ctx.partnerProgram === _ctx.PartnerPrograms.INJURED_GADGETS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  class: "btn btn-primary",
                  to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  class: "btn btn-primary",
                  to: _ctx.RoutePath.HOME_SALES_REPORT
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          _hoisted_10
        ]))
      : _createCommentVNode("", true),
    (_ctx.isHomePage && _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_QuickActions)
            ]),
            (_ctx.salesOverview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_SalesOverview)
                ]))
              : _createCommentVNode("", true),
            (_ctx.salesOverview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_ctx.canViewCompensationAmount)
                    ? (_openBlock(), _createBlock(_component_PayoutCompensationBody, {
                        key: 0,
                        cssContainer: `card fs-7`,
                        cssBody: `card-body p-3 d-flex`
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}